export default {
  isIOS: /iPhone|iPad|iPod/.test(navigator.userAgent),

	getSearch() {
		let search = location.search.slice(1)
		let searchObj = {}
		let key = ""
		let splitArr = []

		if(search) {
			let paramArr = search.split('&')
			for(let i = 0; i < paramArr.length; i++) {
				splitArr = paramArr[i].split("=")
				key = splitArr[0]
				searchObj[key] = splitArr[1]
			}
			return searchObj
		}
		return null
	},

	getCookie: (name) => {
		let cookieValue = null
		if (document.cookie && document.cookie != '') {
			let cookies = document.cookie.split(';')
			for (let i = 0; i < cookies.length; i++) {
				let cookie = cookies[i].trim()
				if (cookie.substr(0, name.length + 1) === (name + '=')) {
					cookieValue = decodeURIComponent(cookie.substring(name.length + 1))
					break
				}
			}
		}
		return cookieValue
	},

	// TODO 不要改变参数的内容，应该返回新的副本
	getBinarySum(array) {
		let sum = 0
		array.map(item => {
			sum += (1 << (item - 1))
		})
		return sum
	},

	//  获取明天的时间戳 毫秒数
	getTomorrowTimeStamp() {
		let date = new Date()
		date.setDate(date.getDate() + 1)
		return date.getTime()
	},

  genderCallbackToken(num = 0) {
	  return `defineCallback_${Date.now() + num}`
  }
}
